module.exports = __webpack_public_path__ + "static/media/gwyneth_walsh.0967ec3c.mp3";